export default __webpack_public_path__ + "static/media/Icon=Approvals.aa76475c.svg";